// application level state

export const initialState = {
  cart: JSON.parse(localStorage.getItem("cart")) || [], // load cart from localStorage
};

export const getCartTotal = (cart) => {
  return cart?.reduce((amount, item) => item.price + amount, 0);
};

const reducer = (state, action) => {
  let updatedCart;
  switch (action.type) {
    case "ADD_TO_CART":
      updatedCart = [...state.cart, action.item];
      localStorage.setItem("cart", JSON.stringify(updatedCart)); // save to localStorage
      return {
        ...state,
        cart: updatedCart,
      };

    case "REMOVE_FROM_CART":
      const index = state.cart.findIndex(
        (cartItem) => cartItem.id === action.id
      );
      updatedCart = [...state.cart];
      if (index >= 0) {
        updatedCart.splice(index, 1);
      } else {
        console.warn(
          `Can't remove product(id: ${action.id}) as not in the cart!`
        );
      }
      localStorage.setItem("cart", JSON.stringify(updatedCart)); // save to localStorage
      return {
        ...state,
        cart: updatedCart,
      };

    default:
      return state;
  }
};

export default reducer;
